export default function() {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    // { label: "账户ID", prop: "store_id", width: 100 },
    { label: "所属企业登录账号", prop: "admin_id", width: 200, slots: "admin_id" },
    // { label: "账户类型", prop: "type", slots: "type", width: 150 },
    { label: "账户号码", prop: "vip_number", width: 130 },
    { label: "负责人姓名", prop: "user_name", width: 130 },
    { label: "负责人手机号", prop: "user_phone", width: 130 },
    // { label: "性别", prop: "sex", width: 80 },
    // { label: "生日", prop: "birthday", width: 140 },
    { label: "余量", prop: "money", width: 160 ,slots: "money",},
    {
      label: "创建时间",
      prop: "create_time",
      width: 180,
      // slots: "state",
    },
    { label: "创建人", prop: "create_user", width: 300 },
    {
      label: "操作",
      prop: "operation",
      width: 100,
      slots: "operation",
      fixed: "right",
    },
    { label: "备注", prop: "msg" , width: 100 },
  ];
}
